/**
 * A stated fact on a quiet ground.
 *
 * Used wherever production has a state the prototype never needed: the source
 * unreachable, the caller unauthorized, a key that matches two facilities. It
 * deliberately does not use a spinner or a generic "something went wrong" —
 * both imply that waiting or retrying will help, and here it usually will not.
 */
export function StateMessage({
  title,
  body,
  detail,
  onRetry,
  children,
}: {
  title: string;
  body: string;
  detail?: string;
  onRetry?: () => void;
  children?: React.ReactNode;
}) {
  return (
    <div className="fw-center">
      <div className="fw-msg">
        <b>{title}</b>
        <span>{body}</span>
        {children}
        {detail && <div className="fw-detail">{detail}</div>}
        {onRetry && (
          <button className="btn btn-p" onClick={onRetry} type="button">
            Try again
          </button>
        )}
      </div>
    </div>
  );
}
